import React, { ReactElement } from 'react';
import { CardIconZ } from '@kursk/components/ui/icons';

import styles from "./IconForCardZ.module.scss";

export function IconForCardZ(): ReactElement {
  return (
    <div className={styles.wrapper}>
      <CardIconZ />
    </div>
  );
}
